import { Link } from "react-router-dom";

const CloseSearch = () => {
  return (
    <Link to="/" className="close-search">
      Close
    </Link>
  );
};

export default CloseSearch;
